var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "filter-item filter-item--category-filter" },
    [
      _c("h2", {
        staticClass: "filter-item__heading",
        domProps: { textContent: _vm._s(_vm.translations.title) }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "filter-stars" },
        _vm._l(_vm.stars, function(star, starKey) {
          return _c(
            "div",
            {
              key: starKey,
              staticClass: "filter-stars__item",
              on: {
                mouseout: function($event) {
                  _vm.hoverStars = -1
                },
                mouseover: function($event) {
                  _vm.hoverStars = starKey + 1
                },
                click: function($event) {
                  _vm.category = starKey + 1
                }
              }
            },
            [
              _c(
                "svg",
                {
                  staticClass: "filter-stars__icon",
                  class: {
                    "filter-stars__icon--filled": star,
                    "filter-stars__icon--hover": _vm.hoverStars >= starKey + 1
                  },
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 31.99 30.39"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      d:
                        "M31.94,11.54a1,1,0,0,0-1-.7H20.26L16.94.69a1,1,0,0,0-1.9,0L11.73,10.84H1a1,1,0,0,0-.95.7,1,1,0,0,0,.36,1.11l8.68,6.28L5.78,29.08A1,1,0,0,0,7.31,30.2L16,23.92l8.68,6.28a1,1,0,0,0,.59.19,1,1,0,0,0,.95-1.31L22.9,18.93l8.67-6.28a1,1,0,0,0,.37-1.11Z"
                    }
                  })
                ]
              )
            ]
          )
        })
      ),
      _vm._v(" "),
      _c("p", { domProps: { textContent: _vm._s(_vm.subText) } })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0d553cae", { render: render, staticRenderFns: staticRenderFns })
  }
}